import { render, staticRenderFns } from "./UpdateParticulars.vue?vue&type=template&id=5d0acc0b"
import script from "./UpdateParticulars.vue?vue&type=script&lang=js"
export * from "./UpdateParticulars.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports